import React, { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  // Fix: Explicitly declare props to satisfy TypeScript if base class inference fails
  declare props: Readonly<ErrorBoundaryProps>;

  public state: ErrorBoundaryState = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught application error:", error, errorInfo);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="h-screen w-screen bg-[#0a1120] flex items-center justify-center p-8 text-center">
          <div className="max-w-md w-full bg-slate-900 border border-red-500/20 rounded-[2.5rem] p-10 shadow-2xl">
            <div className="w-16 h-16 bg-red-500/10 rounded-2xl flex items-center justify-center text-red-500 mx-auto mb-6">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77-1.333.192 3 1.732 3z"/></svg>
            </div>
            <h2 className="text-xl font-black text-white uppercase italic tracking-tight mb-2">Neural Interface Interrupted</h2>
            <p className="text-slate-800 text-sm mb-8 font-medium italic">
              A rendering exception occurred. Beta-1 core has stabilized the UI.
            </p>
            <button 
              onClick={() => window.location.reload()} 
              className="w-full py-4 bg-[#004d7c] hover:bg-cyan-600 text-white rounded-2xl font-black uppercase text-[10px] tracking-widest shadow-xl transition-all"
            >
              Re-initialize Hub
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}